// extracted by mini-css-extract-plugin
export default {"picker":"styles_picker__KV4UI","current":"styles_current__mPiNt","language":"styles_language__XE1Yr","selector":"styles_selector__+VZAR","container":"styles_container__abM6k"};